import { UI_STYLES } from "@/styles/uiStyles";
import { ChatMessageUi } from "../ChatScreenViewModel";
import usersMessageAppendix from "@/assets/img/icons/ic_users_message_appendix.svg";
interface MessageItemYourProps {
  message: ChatMessageUi;
}


export const MessageItemYour = ({ message }: MessageItemYourProps) => {
    return (
      <div className="w-full flex flex-col py-1" style={{ transform: "scaleY(-1)" }}>
        <div className="flex flex-row items-end justify-end pl-20 ">
          <div
            className={`flex flex-col gap-3 ${UI_STYLES.bgEmerald}  rounded-tr-xl rounded-bl-xl rounded-tl-2xl p-2  text-xs `}
          >
            <div className="text-left w-full text-white  font-regular ">
              {message.message}
            </div>
            <div className="text-right text-white  font-regular ">{message.createdAt.toLocaleString()}</div>
          </div>
          <img
            src={usersMessageAppendix}
            alt="user"
            className="w-4 h-7"
          />
        </div>
      </div>
    );
  };